import React from 'react';
import { A } from 'hookrouter';
import CTAButton from 'react-bootstrap/Button';
import { toTitleCase } from 'utils';

const MortgageSignInJointAccountPage = ({ name, onContinue }) => {
  name = toTitleCase(name);
  return (
    <div className="occu-form">
      <h5>Hi {name && `${name}!`}</h5>
      <p>Please click continue to start your application.</p>
      <CTAButton variant="occu-primary" block onClick={onContinue}>
        Continue
      </CTAButton>
      <div>
        {name && (
          <p>
            If {name} will not be a borrower on the application, click <A href="/mortgage/sign-up">here</A> to create
            your individual home loan application login and to apply
          </p>
        )}
      </div>
    </div>
  );
};

export default MortgageSignInJointAccountPage;
